module.exports = __webpack_public_path__ + "static/img/icon-shop-apply-failed.c0f07aef.png";